import { combineReducers } from '@reduxjs/toolkit';
import auth from '../slices/auth/slice';
import callObject from '../slices/callObject/slice';
import google from '../slices/google/slice';
import participants from '../slices/participants/slice';
import recurringMeetings from '../slices/recurringMeetings/slice';
import tracker from '../slices/tracker/slice';
const rootReducer = combineReducers({
  auth,
  callObject,
  google,
  participants,
  recurringMeetings,
  tracker
});
export default rootReducer;